import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import stripProps from '@/lib/utils/stripProps';
import mediaQuery from '@/lib/styling/mediaQuery';
import { type OmitFramerProps } from '@/lib/types';
import isTouchDevice from '@/lib/utils/isTouchDevice';
import { IconButton, type IconButtonProps } from '@mui/material';

export type StyledActionButtonProps = OmitFramerProps<IconButtonProps> & {
  small?: boolean;
  right?: boolean;
  correctRightMargin?: boolean;
};

// eslint-disable-next-line react-refresh/only-export-components
export const StyledActionButton = styled(
  motion.create(stripProps(IconButton, 'small', 'right', 'correctRightMargin')),
)<StyledActionButtonProps>(
  ({ small }) => ({
    marginTop: -12,
    marginBottom: -12,
    display: 'inline-flex',
    ':focus': {
      transform: 'none !important',
      opacity: '1 !important',
    },
    [mediaQuery(560)]: {
      marginLeft: -6,
      marginRight: -6,
      ':last-of-type': {
        marginRight: 0,
      },
    },
    [mediaQuery(640)]: {
      transform: 'none',
      opacity: '1',
    },
    '.MuiSvgIcon-root': {
      width: small ? 16 : undefined,
      height: small ? 16 : undefined,
    },
  }),
  ({ small }) => {
    if (small) {
      return {
        padding: 6,
        width: 38,
        height: 38,
        [mediaQuery(560)]: {
          margin: -6,
        },
      };
    }
  },
  ({ right }) => {
    if (right) {
      return {
        marginLeft: 'auto',
      };
    }
  },
  ({ correctRightMargin }) => {
    if (correctRightMargin) {
      return {
        marginRight: -6,
      };
    }
  },
);

const AnimatedActionButton = (props: StyledActionButtonProps) => {
  const shouldAlwaysShowButton = isTouchDevice();

  return (
    <StyledActionButton
      variants={{
        initial: {
          y: shouldAlwaysShowButton ? 0 : 5,
          opacity: shouldAlwaysShowButton ? 1 : 0,
        },
        hover: {
          y: 0,
          opacity: 1,
        },
      }}
      {...props}
    />
  );
};

export default AnimatedActionButton;
